<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Awards', to: { path: '/awards' } },
        { name: 'Award Info', to: { path: '/awards/award-info' } },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增Award Info</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="editHandler">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
      <button class="btn" @click="deleteHandler">
        <v-icon class="mr-2">delete</v-icon>
        <span>刪除</span>
      </button>
    </div>

    <!-- block -->
    <div class="block">
      <!-- Award Name -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Award Name</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 ">
          Computex Best Choice 2019
        </div>
      </div>
      <!-- Year -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Year</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 ">2019</div>
      </div>
      <!-- Month -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Month</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 ">5月</div>
      </div>
      <!-- Award Type -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Award Type</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 ">Product</div>
      </div>
      <!-- Award Country -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Award Country</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 ">
          台灣
        </div>
      </div>
      <!-- Award Image -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Award Image</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div
            class="w-280px h-187px bg-cover bg-center"
            :style="{
              'background-image': `url(${awardImage})`,
              'border-radius': '8px',
            }"
          ></div>
        </div>
      </div>
      <!-- URL -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>URL</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 ">
          <a :href="url" class="text-decoration-none">{{ url }}</a>
        </div>
      </div>
      <!-- Display Order -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Display Order</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 ">3</div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    Breadscrumbs,
  },
  data: () => ({
    awardName: '',
    year: '',
    month: '',
    awardType: '',
    awardCountry: '',
    awardImage: 'https://dummyimage.com/280x187.jpg',
    url: 'https://awards-demo.url.com',
    displayOrder: '',
  }),
  methods: {
    editHandler() {
      this.$router.push('/awards/award-info/edit');
    },
    deleteHandler() {
      this.$router.push('/awards');
    },
  },
};
</script>

<style></style>
